import React from "react"
import styled from "styled-components"
import { color, breakpoint } from "../../../configs/utilities"

const NavbarHamburger = ({ toggleNav, isOpen }) => {
  return (
    <HamburgerWrapper>
      <button
        onClick={toggleNav}
        onKeyPress={toggleNav}
        className={isOpen ? `navbarBurger toggle` : `navbarBurger`}
      >
        <div className="line line_1"></div>
        <div className="line line_2"></div>
      </button>
    </HamburgerWrapper>
  )
}

export default NavbarHamburger

const HamburgerWrapper = styled.div`
  width: 40px;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: ${breakpoint.xl}) {
    display: none;
  }

  button {
    border: none;
  }

  .navbarBurger {
    cursor: pointer;
    background: transparent;

    .line {
      width: 30px;
      height: 2px;
      margin: 7px;
      background-color: ${color.black};
      transition: all 0.3s ease;
      opacity: 0.7;
    }
  }
  .toggle {
    .line_1 {
      transform: rotate(-45deg) translate(-3.5px, 3.5px);
    }
    .line_2 {
      transform: rotate(45deg) translate(-3.5px, -3.5px);
    }
  }
`
